import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Group } from '../../../core/modules/groups/groups.types';

@Component({
  selector: 'tax-delete-modal',
  templateUrl: 'disallow-group-delete-modal.component.html',
  styleUrls: ['disallow-group-delete-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DisallowGroupDeleteModalComponent {
  // @ts-ignore
  @Input() group: Group;
}
